export default "__VITE_ASSET__z8N9uRBO__"